<app-toasts></app-toasts>
<app-announce></app-announce>
<app-reselect></app-reselect>

<!-- App global -->
@if (firstLoading()) {
  <div
    class="tw-m-auto tw-mt-2 tw-size-20 tw-animate-spin tw-rounded-full tw-border-8 tw-border-solid tw-border-gray-200 tw-border-t-blue-600"
  ></div>
} @else {
  <div class="tw-bg-base-50 tw-text-base-content">
    <router-outlet />
  </div>
}
